export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">联系我们</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">如果你有好的影视资源或建议，欢迎与小辣椒影院取得联系</p>
        <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8 max-w-xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-4">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2">投稿与合作</h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            无论是影视资源分享、内容建议还是商务合作，都欢迎通过以下方式联系我们。
            小辣椒影院致力于为广大影迷提供最优质的免费观影服务。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-sm text-foreground-700">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line text-primary-500"></i>
              投稿邮箱：contact@xiaolajiao.com
            </span>
            <span className="hidden sm:block text-foreground-400">|</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-wechat-line text-accent-500"></i>
              官方微信：小辣椒影院
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}